/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TargetTemplateModel } from '../../models/target-template-model';

export interface GetTargetTemplates$Params {
}

export function GetTargetTemplates(http: HttpClient, rootUrl: string, params?: GetTargetTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TargetTemplateModel>>> {
  const rb = new RequestBuilder(rootUrl, GetTargetTemplates.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TargetTemplateModel>>;
    })
  );
}

GetTargetTemplates.PATH = '/api/Supervisor/GetTargetTemplates';
